import { NEW_LINE, NEW_LINE_PATTERN } from '../constants'

import TextRule from './TextRule'

export default class NewLine extends TextRule {
  getType() {
    return NEW_LINE
  }

  getWidth() {
    return 0
  }

  draw() {}
}

NewLine.pattern = NEW_LINE_PATTERN
